import { useState } from 'react'
import { ChevronRight } from '../../assets/icons/chevron right'
import { Desconectar } from '../../components/Desconectar'
import { EditorTemplate } from '../../components/EditorTemplate'
import { CampoTemplate } from '../../components/EditorTemplate/useEditorTemplate'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import {
  Button,
  Container,
  ContainerInput,
  DivData,
  Span,
  Status,
  Wrapper,
} from './style'
import { useConfiguracoes } from './useConfiguracoes'

type Secao =
  | 'WHATSAPP'
  | 'TEMPLATE_EMAIL'
  | 'TEMPLATE_WHATSAPP'
  | 'TEMPLATE_PDF'
  | null

// Nomes das variáveis (sem o wrapper ${}); o EditorTemplate renderiza o ${}.
const PLACEHOLDERS = ['clienteNome', 'organizacaoNome', 'link']

const CAMPOS_EMAIL: CampoTemplate[] = [
  {
    nome: 'TEMPLATE_ASSUNTO_EMAIL_PEDIDO',
    label: 'Assunto do e-mail',
    tipo: 'input',
  },
  {
    nome: 'TEMPLATE_EMAIL_PEDIDO',
    label: 'Corpo do e-mail (HTML)',
    tipo: 'textarea',
    preview: true,
    placeholders: PLACEHOLDERS,
    rows: 20,
  },
]

// O PDF do pedido tem um modelo proprio: alem do cliente, sai a quantidade de dias usada no
// calculo e a marca do cabecalho (a logo da organizacao quando cadastrada, senao a Cartivia).
const PLACEHOLDERS_PDF = [
  'organizacaoNome',
  'vendedorNome',
  'clienteNome',
  'clienteCpfcnpj',
  'clienteTelefone',
  'numeroDias',
  'dataGeracao',
  'logoDataUri',
  'logoLargura',
  'logoAltura',
  'logoProprio',
]

const PRODUTO_PLACEHOLDERS_PDF = [
  'produtos[i].nome',
  'produtos[i].codigoIntegracao',
  'produtos[i].quantidade',
]

const NOTA_PDF =
  'A quantidade já vem formatada (ex.: 7,50) — não use descriptionDecimal aqui. ' +
  'A lista oportunidades[] (Mix Inteligente) tem os mesmos campos por item e pode vir vazia; ' +
  'percorra-a com um laço próprio e proteja a seção com um if, para não sobrar um cabeçalho sozinho. ' +
  'Atenção: o PDF é gerado por um leitor XHTML — todas as tags precisam estar fechadas ' +
  '(use <br /> e não <br>) e, fora dos blocos <% %>, o sinal de menor só pode aparecer abrindo uma tag. ' +
  'Um template malformado faz a geração falhar; use "Copiar padrão do sistema" para recomeçar.'

const CAMPOS_PDF: CampoTemplate[] = [
  {
    nome: 'TEMPLATE_PDF_PEDIDO',
    label: 'Layout do PDF do pedido (XHTML)',
    tipo: 'textarea',
    preview: true,
    placeholders: PLACEHOLDERS_PDF,
    produtoPlaceholders: PRODUTO_PLACEHOLDERS_PDF,
    nota: NOTA_PDF,
    rows: 24,
  },
]

const CAMPOS_WHATSAPP: CampoTemplate[] = [
  {
    nome: 'TEMPLATE_WHATSAPP_PEDIDO',
    label: 'Mensagem do WhatsApp',
    tipo: 'textarea',
    placeholders: PLACEHOLDERS,
    rows: 12,
  },
]

export function Configuracoes() {
  const [secao, setSecao] = useState<Secao>(null)
  const {
    instancia,
    handleDeletaInstancia,
    fechaDesconectarInstancia,
    desconectarInstancia,
    desconectar,
  } = useConfiguracoes(secao === 'WHATSAPP')

  const toggle = (alvo: Secao) => setSecao(secao === alvo ? null : alvo)

  return (
    <>
      <DivTitle color="black" size={24}>
        Configurações
      </DivTitle>
      <Container>
        <div>
          <Button
            buttonType={secao === 'WHATSAPP' ? 'DATA' : 'PSWD'}
            type="button"
            onClick={() => toggle('WHATSAPP')}
          >
            WhatsApp <ChevronRight white={secao === 'WHATSAPP'} />
          </Button>
          <Button
            buttonType={secao === 'TEMPLATE_EMAIL' ? 'DATA' : 'PSWD'}
            type="button"
            onClick={() => toggle('TEMPLATE_EMAIL')}
          >
            Template de E-mail{' '}
            <ChevronRight white={secao === 'TEMPLATE_EMAIL'} />
          </Button>
          <Button
            buttonType={secao === 'TEMPLATE_WHATSAPP' ? 'DATA' : 'PSWD'}
            type="button"
            onClick={() => toggle('TEMPLATE_WHATSAPP')}
          >
            Template de WhatsApp{' '}
            <ChevronRight white={secao === 'TEMPLATE_WHATSAPP'} />
          </Button>
          <Button
            buttonType={secao === 'TEMPLATE_PDF' ? 'DATA' : 'PSWD'}
            type="button"
            onClick={() => toggle('TEMPLATE_PDF')}
          >
            Template de PDF do pedido{' '}
            <ChevronRight white={secao === 'TEMPLATE_PDF'} />
          </Button>
        </div>

        {secao === 'WHATSAPP' && (
          <DivData>
            <h2>Configuração de WhatsApp</h2>
            <Wrapper>
              <Span>
                <b>Instância:</b>{' '}
                {instancia.ativo ? (
                  <ContainerInput color="green">
                    <Status>
                      <em>Ativa</em>
                    </Status>
                  </ContainerInput>
                ) : (
                  <ContainerInput color="grey">
                    <Status>
                      <em>Inativa</em>
                    </Status>
                  </ContainerInput>
                )}
              </Span>
              {instancia.ativo ? (
                <Span>
                  <b>Status:</b>{' '}
                  {instancia.conectado ? (
                    <ContainerInput color="green">
                      <Status>
                        <em>Conectado</em>
                        <em>{instancia.numero}</em>
                      </Status>
                    </ContainerInput>
                  ) : (
                    <ContainerInput>
                      <Status>
                        <em>
                          <img src={instancia.qrcode} alt="qrCode" />
                        </em>
                        <em>Desconectado</em>
                      </Status>
                    </ContainerInput>
                  )}
                </Span>
              ) : (
                ''
              )}
              {instancia.ativo ? (
                <Button
                  marginTop="15px"
                  buttonType="DATA"
                  type="button"
                  onClick={handleDeletaInstancia}
                >
                  Desconectar
                </Button>
              ) : (
                ''
              )}
            </Wrapper>
          </DivData>
        )}

        {secao === 'TEMPLATE_EMAIL' && (
          <EditorTemplate titulo="Template de E-mail" campos={CAMPOS_EMAIL} />
        )}

        {secao === 'TEMPLATE_WHATSAPP' && (
          <EditorTemplate
            titulo="Template de WhatsApp"
            campos={CAMPOS_WHATSAPP}
          />
        )}

        {secao === 'TEMPLATE_PDF' && (
          <EditorTemplate
            titulo="Template de PDF do pedido"
            campos={CAMPOS_PDF}
          />
        )}

        {desconectarInstancia && (
          <Desconectar
            texto="Deseja realmente desconectar esta instância?"
            botaoNao={() => {
              fechaDesconectarInstancia()
            }}
            botaoSim={desconectar}
          />
        )}
      </Container>
    </>
  )
}
